<template>
  <!-- 充电订单 -->
  <div class="app-container">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item label="手机号码">
        <el-input placeholder="请输入手机号码" v-model="filter.user_phones" clearable></el-input>
      </el-form-item>
      <el-form-item label="内容">
        <el-input placeholder="请输入内容" v-model="filter.content" clearable></el-input>
      </el-form-item>
      <el-form-item label="时间" prop="date">
        <el-date-picker v-model="filter.date" type="datetimerange" start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
      </el-form-item>
    </el-form>

    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading">
      <el-table-column label="序号" type="index" width="80" align="center"></el-table-column>
      <el-table-column label="手机号码" prop="user_phones" width="140" align="center"></el-table-column>
      <el-table-column label="状态" prop="resp_flag" width="80" align="center">
        <template slot-scope="{ row }">
          <el-tag type="success" v-if="row.status == 1">成功</el-tag>
          <el-tag type="danger" v-else>失败</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="短信内容" prop="content" align="center"></el-table-column>
      <el-table-column label="创建时间" prop="create_time" width="160" align="center"></el-table-column>

      <el-table-column :label="$t('publics.operation')" width="100" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="onDetail(row)" v-permision_tjtf="'detail'">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination
        background
        layout="sizes,total,prev,pager,next,jumper"
        :total="pageParams.total"
        :page-size="pageParams.limit"
        :page-sizes="[5, 10, 50, 100, 500, 1000]"
        :current-page="pageParams.page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <el-dialog :visible.sync="detailVisible" title="详情" width="1200px" :close-on-click-modal="false">
      <el-row type="flex" justify="center">
        <el-col :span="24">
          <el-form label-position="right" label-width="120px" :model="detailForm" ref="detailForm">
            <el-row :gutter="20">
              <!-- 第一列 -->
              <el-col :span="12">
                <el-form-item label="编号" prop="ID">
                  {{ detailForm.ID }}
                </el-form-item>
                <el-form-item label="手机号" prop="user_phones">
                  <el-input v-model="detailForm.user_phones" readonly disabled />
                </el-form-item>

                <el-form-item label="状态" prop="faultSum">
                  <el-tag type="success" v-if="detailForm.status == 1">成功</el-tag>
                  <el-tag type="danger" v-else>失败</el-tag>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                  <el-input v-model="detailForm.remark" readonly disabled />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <!-- 第2行 -->
              <el-col :span="24">
                <el-form-item label="发送内容" prop="ID">
                  {{ detailForm.content }}
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import fileUpload from "@/components/fileUpload/fileUpload.vue"
import { getSmsLogPageList } from "@/api/sms_log"
import { mapGetters } from "vuex"
export default {
  name: "GroupManage",
  mixins: [pageMixin],
  components: { fileUpload },
  data() {
    return {
      detailForm: {},
      detailVisible: false,
      visible: {
        editGroup: false
      },
      tableData: [],
      filter: {
        assets_code: "",
        dev_type: ""
      },
      loading: false,
      isUpdate: true,
      gid: "" //街道id
    }
  },

  computed: {
    ...mapGetters(["userInfo"]),
    respFlagText() {
      if (this.detailForm.resp_flag === 1) {
        return "已回复"
      } else if (this.detailForm.resp_flag === 0) {
        return "未回复"
      } else {
        return this.detailForm.resp_flag
      }
    }
  },
  created() {
    this.getData()
  },
  methods: {
    onDetail(row) {
      this.detailForm = { ...row }
      this.detailVisible = true
    },
    getData() {
      let startTime = "",
        endTime = ""
      this.loading = true
      if (this.filter.date && this.filter.date.length) {
        startTime = this.filter.date[0]
        endTime = this.filter.date[1]
      }

      this.loading = true
      getSmsLogPageList({
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        assets_code: this.filter.assets_code || null,
        dev_type: this.filter.dev_type || null,
        start_time: startTime,
        end_time: endTime
      })
        .then((res) => {
          this.tableData = res.data

          this.pageParams.total = res.total
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.p-20 {
  padding: 20px;
}
</style>
